import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import Avatar from '@material-ui/core/Avatar';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/LockOutline';

import defaultTheme from './defaultTheme';
import Notification from './Notification';
import DefaultLoginForm from './LoginForm';
//import xsquad from 'assets/x-squad_and_apo.png';
import logo from 'assets/logoF.png';

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '1px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    background:
      'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAxIDEiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPjxsaW5lYXJHcmFkaWVudCBpZD0idnNnZyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPjxzdG9wIHN0b3AtY29sb3I9IiM3YjNmNzUiIHN0b3Atb3BhY2l0eT0iMSIgb2Zmc2V0PSIwIi8+PHN0b3Agc3RvcC1jb2xvcj0iI2MyNGQ2NyIgc3RvcC1vcGFjaXR5PSIxIiBvZmZzZXQ9IjEiLz48L2xpbmVhckdyYWRpZW50PjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9InVybCgjdnNnZykiIC8+PC9zdmc+)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  card: {
    minWidth: 300,
    marginTop: '6em'
  },
  avatar: {
    margin: '1em',
    display: 'flex',
    justifyContent: 'center'
  },
  icon: {
    backgroundColor: theme.palette.secondary[500]
  }
});

const sanitizeRestProps = ({
  classes,
  className,
  location,
  title,
  array,
  theme,
  staticContext,
  ...rest
}) => rest;

/**
 * A standalone login page, to serve as authentication gate to the admin
 *
 * Expects the user to enter a login and a password, which will be checked
 * by the `authProvider` using the AUTH_LOGIN verb. Redirects to the root page
 * (/) upon success, otherwise displays an authentication error message.
 *
 * Copy and adapt this component to implement your own login logic
 * (e.g. to authenticate via email or facebook or anything else).
 *
 * @example
 *     import MyLoginPage from './MyLoginPage';
 *     const App = () => (
 *         <Admin loginPage={MyLoginPage} authProvider={authProvider}>
 *             ...
 *        </Admin>
 *     );
 */
const MyLoginPage = ({ classes, className, loginForm, theme, ...rest }) => (
  <MuiThemeProvider theme={theme}>
    <div
      className={classnames(classes.main, className)}
      {...sanitizeRestProps(rest)}
    >
      <Card className={classes.card}>
        <div className={classes.avatar}>
          <Avatar className={classes.icon}>
            <LockIcon />
          </Avatar>
        </div>
        {loginForm}
      </Card>
      <div>
        {/* <div class="cardImage"> */}
        <img
          style={{ marginTop: 50 }}
          src={logo}
          alt=""
          width="200px"
          //height="133px"
        />
      </div>
      <Notification />
    </div>
  </MuiThemeProvider>
);

MyLoginPage.propTypes = {
  className: PropTypes.string,
  authProvider: PropTypes.func,
  classes: PropTypes.object,
  input: PropTypes.object,
  meta: PropTypes.object,
  previousRoute: PropTypes.string,
  loginForm: PropTypes.element
};

MyLoginPage.defaultProps = {
  theme: defaultTheme,
  loginForm: <DefaultLoginForm />
};

export default withStyles(styles)(MyLoginPage);



// WEBPACK FOOTER //
// ./src/components/login/MyLoginPage.js